import { useDroppable } from '@dnd-kit/core';
import { Box } from '@mui/material';

import { usePreferences } from '@/react-query/usePreferences';

export const DroppableContainer = ({ id }: { id?: string }) => {
  const {
    setNodeRef,
    isOver: isDraggingOver,
    over: isDragging,
  } = useDroppable({
    id: id ?? 'droppable',
  });

  const { data: prefs } = usePreferences();
  const shouldUseSidebarRedesign = prefs?.useSidebarRedesign;

  return (
    <Box
      
      data-testid="droppable-box"
      ref={setNodeRef}
      width="25px"
      height="65px"
      minWidth={shouldUseSidebarRedesign ? '48px' : undefined}
      margin="8px 16px"
      border={isDragging ? '5px dashed rgba(155, 155, 155, 0.5)' : ''}
      borderColor={isDraggingOver ? 'white' : ''}
      borderRadius="16px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      boxSizing="border-box"
      flexGrow={1}
    />
  );
};
